import ApplicantForm from "./ApplicantData";
import FatherForm from "./FatherForm";
import MotherForm from "./MotherForm";

interface ApplicantProps {
  nationality: any;
  academicLevels: any;
  deathReasons: any;
  maritalStatus: any;
  healthStates: any;
  identificationTypes: any;
  form: any;
}

const ApplicantData = ({
  nationality,
  academicLevels,
  deathReasons,
  maritalStatus,
  healthStates,
  identificationTypes,
  form,
}: ApplicantProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <ApplicantForm form={form} identificationTypes={identificationTypes} />
      <FatherForm
        nationality={nationality}
        deathReasons={deathReasons}
        identificationTypes={identificationTypes}
        form={form}
      />
      <MotherForm
        nationality={nationality}
        maritalStatus={maritalStatus}
        healthStates={healthStates}
        academicLevels={academicLevels}
        identificationTypes={identificationTypes}
        form={form}
      />
    </div>
  );
};

export default ApplicantData;
